module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_6.43da06f0.jpeg";